import { useRouteMatch } from 'react-router';
import { useTypedSelector } from '../../redux/hooks';
import { SubjectGeneric } from '../../redux/slices/subjects/slice';
import PermissionRequired from '../Auth/AuthRequired/PermissionRequired';
import { useEffect, useState } from 'react';

interface BusinessParams {
  businessId: string;
}

interface OrganizerParams {
  organizerId: string;
}

type Props = { children?: React.ReactNode };

/*
 * Used for Business and Organizer Apps
 */
const PermissionLayer: React.FC<Props> = ({ children }) => {
  const businessSet = useTypedSelector(s => s.subjects.businessSet);
  const organizerSet = useTypedSelector(s => s.subjects.organizerSet);

  const businessMatch = useRouteMatch('/business/:businessId');
  const organizerMatch = useRouteMatch('/organizer/:organizerId');

  const [isPermissionExist, setIsPermissionExists] = useState(false);
  // const [activeSubject, setActiveSubject] = useState<SubjectGeneric>();

  useEffect(() => {
    let _isPermissionExist = false;
    let _activeSubject: SubjectGeneric;

    if (businessMatch) {
      const businessId = (businessMatch.params as BusinessParams).businessId;
      _isPermissionExist = !!businessSet?.find(
        business => business.id === businessId
      );
      _activeSubject = {
        contentType: 'business',
        objectId: businessId,
      };
    } else if (organizerMatch) {
      const organizerId = (organizerMatch.params as OrganizerParams)
        .organizerId;
      _isPermissionExist = !!organizerSet?.find(
        organizer => organizer.id === organizerId
      );
      _activeSubject = {
        contentType: 'organizer',
        objectId: organizerId,
      };
    }

    setIsPermissionExists(_isPermissionExist);
  }, [businessMatch, organizerMatch, businessSet, organizerSet]);

  if (isPermissionExist) {
    return <>{children}</>;
  } else {
    return <PermissionRequired />;
  }
};

export default PermissionLayer;
